import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ObjectGalleryService} from '../services/object-gallery.service';
import {SharedService} from '../services/shared.service';
import {ObjectGalleryEnlargedItem} from '../interfaces/object-gallery-enlarged-item';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Router} from '@angular/router';

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'mak-object-gallery-enlarged',
  templateUrl: './object-gallery-enlarged.component.html',
  styleUrls: ['./object-gallery-enlarged.component.scss']
})
export class ObjectGalleryEnlargedComponent implements OnInit, OnDestroy {

  @ViewChild('myPinch', {static: false}) myPinch: any;

  enlargedItem: ObjectGalleryEnlargedItem = {
    item: undefined,
    sourcePosition: {
      top: 0,
      left: 0
    }
  };

  state = false;
  imageViewportSize = '100px';
  srcSet = '';
  videoUrl = '';

  constructor(
    private objectGallery: ObjectGalleryService,
    private sharedService: SharedService,
    private router: Router) {
    this.imageViewportSize = window.innerWidth + 'px';
  }

  ngOnInit(): void {
    this.objectGallery.getEnlargedItemUpdates()
      .pipe(untilDestroyed(this))
      .subscribe((response) => {
      if (response !== null) {
        this.enlargedItem = Object.assign({}, response);
        this.videoUrl = response.videoUrl ?? '';
        if (this.enlargedItem.item?.src.indexOf('gif') === -1) {
          this.srcSet = this.enlargedItem.item?.srcSet ?? '';
        } else {
          this.srcSet = this.enlargedItem.item?.src ?? '';
        }
        this.state = true;
        this.sharedService.toggleBodyScroll(false);
      } else {
        this.state = false;
        this.videoUrl = '';
        this.sharedService.toggleBodyScroll(true);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.myPinch) {
      this.myPinch.toggleZoom();
      this.myPinch.destroy();
    }
  }

  closeEnlargedImage(): void {
    this.objectGallery.closeImage();
    if (this.router.url.startsWith('/video/')) {
      this.router.navigate(['/']);
    }
  }
}
